import { lazy, Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';

// Lazy Loading & default exports for Page Components
const Landing = lazy(() =>
  import('../Landing').then((module) => ({ default: module.Landing }))
);
const Contact = lazy(() =>
  import('../Contact').then((module) => ({ default: module.Contact }))
);
const Work = lazy(() =>
  import('../Work').then((module) => ({ default: module.Work }))
);
const Services = lazy(() =>
  import('../Services').then((module) => ({ default: module.Services }))
);
const NotFound = lazy(() =>
  import('../NotFound').then((module) => ({ default: module.NotFound }))
);

// Service Pages
const WebDevelopmentPage = lazy(() =>
  import('../Services/WebDevelopmentPage').then((module) => ({
    default: module.WebDevelopmentPage,
  }))
);
const MobileDevelopmentPage = lazy(() =>
  import('../Services/MobileDevelopmentPage').then((module) => ({
    default: module.MobileDevelopmentPage,
  }))
);
const WebDesignPage = lazy(() =>
  import('../Services/WebDesignPage').then((module) => ({
    default: module.WebDesignPage,
  }))
);
const EcommercePage = lazy(() =>
  import('../Services/EcommercePage').then((module) => ({
    default: module.EcommercePage,
  }))
);
const SmallBusinessPage = lazy(() =>
  import('../Services/SmallBusinessPage').then((module) => ({
    default: module.SmallBusinessPage,
  }))
);
const ConsultingPage = lazy(() =>
  import('../Services/ConsultingPage').then((module) => ({
    default: module.ConsultingPage,
  }))
);
const SEOPage = lazy(() =>
  import('../Services/SEOPage').then((module) => ({ default: module.SEOPage }))
);
const SocialMediaPage = lazy(() =>
  import('../Services/SocialMediaPage').then((module) => ({
    default: module.SocialMediaPage,
  }))
);

export function Main() {
  return (
    <main id="main" tabIndex={-1}>
      <Suspense fallback={<div className="route-fallback" aria-busy="true" />}>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/work" element={<Work />} />
          <Route path="/services" element={<Services />} />

          {/* Service Sub-pages */}
          <Route
            path="/services/web-development"
            element={<WebDevelopmentPage />}
          />
          <Route
            path="/services/mobile-apps"
            element={<MobileDevelopmentPage />}
          />
          <Route path="/services/web-design" element={<WebDesignPage />} />
          <Route path="/services/ecommerce" element={<EcommercePage />} />
          <Route
            path="/services/small-business"
            element={<SmallBusinessPage />}
          />
          <Route path="/services/consulting" element={<ConsultingPage />} />
          <Route path="/services/seo" element={<SEOPage />} />
          <Route path="/services/social-media" element={<SocialMediaPage />} />

          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </main>
  );
}
